import styles from './JobBadge.module.css';
import type { Profession } from '@/types/worker';

interface JobBadgeProps {
    profession: Profession;
}

export function JobBadge({ profession }: JobBadgeProps) {
    return (
        <span className={styles.badge}>
            {profession.icon && <span className={styles.icon}>{profession.icon}</span>}
            {profession.name}
        </span>
    );
}
